import { IPurchaseAddEditRequest } from '../../../../model/scp/purchase/request/purchase-add-edit-request';
import { IItemPurchaseAddEditRequest } from '../../../../model/scp/purchase/request/purchase-item-add-edit-request';
import { IAddPurchaseItemResultRequest } from '../../../../model/scp/purchase-item-result/request/add-purchase-item-result-request';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';
import { isEmptyAmount } from '../../shared/scp-utils';

export type PurchaseField = 'clientId' | 'typeCallingInstrumentId' | 'modalityId' | 'disputeModeId' | 'legalSupportId' | 'codBuyerUnit'
    | 'yearPurchase' | 'numberPurchase' | 'title' | 'objectPurchase' | 'typeDocumentId' | 'file';

// Na inclusão, título e documento acompanham o cadastro; na edição o título não pode ser alterado
export function validatePurchase(request: IPurchaseAddEditRequest, options: { isEdit: boolean; hasFile: boolean }): ValidationErrors<PurchaseField> {
    const errors: ValidationErrors<PurchaseField> = {};
    if (isEmptyId(request.clientId)) errors.clientId = 'Entidade é obrigatória';
    if (isEmptyId(request.typeCallingInstrumentId)) errors.typeCallingInstrumentId = 'Instrumento convocatório é obrigatório';
    if (isEmptyId(request.modalityId)) errors.modalityId = 'Modalidade é obrigatória';
    if (isEmptyId(request.disputeModeId)) errors.disputeModeId = 'Modo de disputa é obrigatório';
    if (isEmptyId(request.legalSupportId)) errors.legalSupportId = 'Amparo legal é obrigatório';
    if (isBlank(request.codBuyerUnit)) errors.codBuyerUnit = 'Unidade compradora é obrigatória';
    if (isEmptyId(request.yearPurchase)) errors.yearPurchase = 'Exercício é obrigatório';
    if (isBlank(request.numberPurchase)) errors.numberPurchase = 'Número é obrigatório';
    if (isBlank(request.objectPurchase)) errors.objectPurchase = 'Objeto é obrigatório';
    if (!options.isEdit) {
        if (isBlank(request.title)) errors.title = 'Título é obrigatório';
        if (isEmptyId(request.typeDocumentId)) errors.typeDocumentId = 'Tipo de documento é obrigatório';
        if (!options.hasFile) errors.file = 'Arquivo é obrigatório';
    }
    return errors;
}

export type PurchaseItemField = 'typeItemId' | 'categoryItemId' | 'typeBenefitId' | 'criterionJudgmentId' | 'unitMeasure'
    | 'unitValueEstimated' | 'quantity' | 'description' | 'realEstateRegistryCode';

// Categoria "1" (bens imóveis) exige o código de registro imobiliário
export const REAL_ESTATE_CATEGORY = '1';

export function validatePurchaseItem(item: IItemPurchaseAddEditRequest): ValidationErrors<PurchaseItemField> {
    const errors: ValidationErrors<PurchaseItemField> = {};
    if (isEmptyId(item.typeItemId ?? item.typeItem)) errors.typeItemId = 'Tipo é obrigatório';
    if (isEmptyId(item.categoryItemId)) errors.categoryItemId = 'Categoria é obrigatória';
    if (isEmptyId(item.typeBenefitId)) errors.typeBenefitId = 'Tipo de benefício é obrigatório';
    if (isEmptyId(item.criterionJudgmentId)) errors.criterionJudgmentId = 'Critério de julgamento é obrigatório';
    if (isBlank(item.unitMeasure)) errors.unitMeasure = 'Unidade de medida é obrigatória';
    if (isEmptyAmount(item.unitValueEstimated)) errors.unitValueEstimated = 'Valor unitário estimado é obrigatório';
    if (isEmptyAmount(item.quantity)) errors.quantity = 'Quantidade é obrigatória';
    if (isBlank(item.description)) errors.description = 'Descrição é obrigatória';
    if (String(item.categoryItemId) === REAL_ESTATE_CATEGORY && isBlank(item.realEstateRegistryCode)) {
        errors.realEstateRegistryCode = 'Código de registro imobiliário é obrigatório para bens imóveis';
    }
    return errors;
}

export type PurchaseItemResultField = 'personTypeId' | 'supplierNi' | 'supplierCompanyName' | 'supplierSizeId' | 'approvedQuantity' | 'approvedUnitPrice';

export function validatePurchaseItemResult(result: IAddPurchaseItemResultRequest): ValidationErrors<PurchaseItemResultField> {
    const errors: ValidationErrors<PurchaseItemResultField> = {};
    if (isBlank(result.personTypeId)) errors.personTypeId = 'Tipo de pessoa é obrigatório';
    if (isBlank(result.supplierNi)) errors.supplierNi = 'Documento do fornecedor é obrigatório';
    if (isBlank(result.supplierCompanyName)) errors.supplierCompanyName = 'Razão social é obrigatória';
    if (isEmptyId(result.supplierSizeId)) errors.supplierSizeId = 'Porte do fornecedor é obrigatório';
    if (!(Number(result.approvedQuantity) > 0)) errors.approvedQuantity = 'Quantidade homologada deve ser maior que zero';
    if (!(Number(result.approvedUnitPrice) > 0)) errors.approvedUnitPrice = 'Preço unitário deve ser maior que zero';
    return errors;
}
